<template>
  <div>
    <!--LABORATORIO-->
    <ed-modal
      title="Inserir Laboratório"
      :modal="showForm"
      :onSave="onRegister"
      width="50%"
    >
      <div slot="modal-content" class="text-left">
        <ed-form :data="formData" :config="config" :itens="formItems" />
      </div>
    </ed-modal>

    <div class="mb-2 text-left">
      <ed-button
        icon="fa fa-plus-circle"
        type="text"
        @click="showForm = !showForm"
        value="Inserir Novo Laboratório"
      />
    </div>

    <div class="text-left">
      <b-table
        class="table-v2"
        striped
        hover
        bordered
        small
        show-empty
        sort-icon-left
        responsive
        head-variant="light"
        empty-text="Nenhum laboratório encontrado"
        :busy="config.loading.content"
        :items="tableData"
        :fields="tableHedad"
        :stacked="this.device == 'xs'"
      >
        <!--FORMATAR CABEÇALHO-->
        <template v-slot:head()="data">
          <span style="font-size: 7pt">{{ data.label.toUpperCase() }}</span>
        </template>

        <!--FORMATAR COLUNAS-->
        <template v-slot:cell()="data">
          <!--MONEY-->
          <div v-if="data.field && data.field.show_money">
            <el-input
              @change="formatData"
              v-model="data.item._data[data.field.key]"
              v-mask="'money'"
              prefix-icon="fa fa-usd"
            />
          </div>

          <!--RADIO-->
          <div
            v-else-if="
              data.field && data.field.show_radio && data.item._data.laboratorio
            "
          >
            <el-radio
              v-model="parent.formData.id_lab"
              :label="data.item._data.laboratorio.id"
            >
              Padrão
            </el-radio>
          </div>

          <div v-else>
            {{ data.value }}
          </div>
        </template>

        <template v-slot:cell(buttons)="data">
          <div class="text-centers">
            <ed-button
              icon="fa fa-trash"
              type="danger"
              size="mini"
              title="Deletar Registro"
              @click="onDelete(data)"
            />
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import Rest from "common/rest";
import EdForm from "common/form";
import EdButton from "common/button";
import EdModal from "common/modal";
import FormItems from "../_form/laboratorio-cadastrar";

export default {
  name: "exame-editar",
  components: { EdForm, EdButton, EdModal },
  mixins: [Rest],
  props: {
    parent: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  watch: {
    "parent.formData.id"() {
      this.inicialize();
    },
  },
  data() {
    return {
      config: {
        tipo: [],
        hidden: {},
        click: {
          laboratorio: this.getLaboratorio,
        },
        loading: {
          laboratorio: false,
        },
        list: {
          laboratorio: [],
        },
      },
      formData: {
        laboratorio: null,
      },
      response: {},
      formItems: [],
      showForm: false,
      tableData: [],
      tableHedad: [
        {
          key: "laboratorio",
          sortable: true,
          label: "Laboratório",
        },
        {
          key: "valor_custo",
          show_money: true,
          label: "Valor Custo (R$)",
          width: "130px",
        },
        {
          key: "valor_venda",
          show_money: true,
          label: "Valor Venda (R$)",
          width: "130px",
        },
        {
          key: "id_lab",
          show_radio: true,
          label: "Padrao",
          width: "90px",
        },
        {
          key: "buttons",
          label: "",
          width: "50px",
        },
      ],
    };
  },

  mounted: function () {
    this.formItems = FormItems;
    this.getLaboratorio();
    this.inicialize();
  },

  methods: {
    inicialize() {
      var tableData = [];

      for (let i = 0; i < this.parent.formData.laboratorios.length; i++) {
        const element = this.parent.formData.laboratorios[i];

        var item = {
          id_lab: element.laboratorio.id,
          laboratorio: element.laboratorio.nome,
          valor_custo: element.valor_custo,
          valor_venda: element.valor_venda,
          _data: element,
        };

        tableData.push(item);
      }

      this.tableData = tableData;
    },

    onRegister() {
      if (!this.formData.laboratorio) {
        this.edAlert("Por favor selecione um laboratório", "error");
        return;
      }

      if (
        this.arrFindByField(
          this.tableData,
          "id_lab",
          this.formData.laboratorio.id
        )
      ) {
        this.edAlert("O laboratório selecionado já está cadastrado", "error");
        return;
      }

      var data = {
        id: 0,
        id_lab: this.formData.laboratorio.id,
        laboratorio: this.formData.laboratorio,
        valor_custo: "0,00",
        valor_venda: "0,00",
      };

      this.tableData.push({
        id: 0,
        id_lab: this.formData.laboratorio.id,
        laboratorio: this.formData.laboratorio.nome,
        valor_custo: "0,00",
        valor_venda: "0,00",
        _data: data,
      });

      this.showForm = !this.showForm;
      this.formData.laboratorio = null;
      this.formatData();
    },

    onDelete(item) {
      this.tableData.splice(item.index, 1);
      this.formatData();
    },

    formatData() {
      this.parent.formData.laboratorios = [];

      for (let i = 0; i < this.tableData.length; i++) {
        const element = this.tableData[i];
        this.parent.formData.laboratorios.push(element._data);
      }
    },

    getLaboratorio: function (_search) {
      this.config.loading.laboratorio = true;
      this.config.list.laboratorio = [];

      this.get("laboratorio", { search: _search }).then((result) => {
        result = result[0];
        this.config.loading.laboratorio = false;

        if (result.status == 200) {
          this.config.list.laboratorio = result.data.data;
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// laboratorio.vue?d04dce96